import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import HomeProfilePage from 'src/pages/home-profile';
import { BlogListView } from 'src/sections/blog/view';
import VuongTrongListPage from 'src/pages/dashboard/vuontrong/list';
import VuongTrongEditPage from 'src/pages/dashboard/vuontrong/edit';
import VuongTrongNewPage from 'src/pages/dashboard/vuontrong/new'; 
import TraCuuLoSamPage from 'src/pages/dashboard/losam/tracuu';
import LoSamListPage from 'src/pages/dashboard/losam/list';
import LoSamEditPage from 'src/pages/dashboard/losam/edit';
import LoSamNewPage from 'src/pages/dashboard/losam/new';
import AccountListPage from 'src/pages/dashboard/account/list';
import AccountEditPage from 'src/pages/dashboard/account/edit';
import AccountNewPage from 'src/pages/dashboard/account/new';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));
const OverviewEcommercePage = lazy(() => import('src/pages/dashboard/ecommerce'));
const OverviewAnalyticsPage = lazy(() => import('src/pages/dashboard/analytics'));
const OverviewBankingPage = lazy(() => import('src/pages/dashboard/banking'));
const OverviewBookingPage = lazy(() => import('src/pages/dashboard/booking'));
const OverviewFilePage = lazy(() => import('src/pages/dashboard/file'));
// USER
const UserProfilePage = lazy(() => import('src/pages/dashboard/user/profile')); 
const UserCardsPage = lazy(() => import('src/pages/dashboard/user/cards'));
const UserListPage = lazy(() => import('src/pages/dashboard/user/list'));
const UserAccountPage = lazy(() => import('src/pages/dashboard/user/account'));
const UserCreatePage = lazy(() => import('src/pages/dashboard/user/new'));
const UserEditPage = lazy(() => import('src/pages/dashboard/user/edit'));
// BLOG  
const BlogPostsPage = lazy(() => import('src/pages/dashboard/blog/list'));
const BlogPostPage = lazy(() => import('src/pages/dashboard/blog/details'));
const BlogNewPostPage = lazy(() => import('src/pages/dashboard/blog/new'));
const BlogEditPostPage = lazy(() => import('src/pages/dashboard/blog/edit'));
// ARTICLE TYPE
const ArticleTypeListPage = lazy(() => import('src/pages/dashboard/article-type/list'));
const ArticleTypeDetailsPage = lazy(() => import('src/pages/dashboard/article-type/details'));
const ArticleTypeCreatePage = lazy(() => import('src/pages/dashboard/article-type/new'));
const ArticleTypeEditPage = lazy(() => import('src/pages/dashboard/article-type/edit'));
// FILE MANAGER
const FileManagerPage = lazy(() => import('src/pages/dashboard/file-manager'));
// TEST RENDER PAGE BY ROLE
const PermissionDeniedPage = lazy(() => import('src/pages/dashboard/permission'));
// BLANK PAGE
const BlankPage = lazy(() => import('src/pages/dashboard/blank'));
// VAI TRO
const RoleListPage = lazy(() => import('src/pages/dashboard/vaitro/list'));
const RoleNewPage = lazy(() => import('src/pages/dashboard/vaitro/new'));
const RoleEditPage = lazy(() => import('src/pages/dashboard/vaitro/edit'));

// MENU
const MenuListPage = lazy(() => import('src/pages/dashboard/menu/list'));
const MenuNewPage = lazy(() => import('src/pages/dashboard/menu/new'));
const MenuEditPage = lazy(() => import('src/pages/dashboard/menu/edit'));

// // HOME PROFILE PAGE 
// const HomeProfilePage = lazy(() => import('src/pages/home-profile'));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'ecommerce', element: <OverviewEcommercePage /> },
      { path: 'analytics', element: <OverviewAnalyticsPage /> },
      { path: 'banking', element: <OverviewBankingPage /> },
      { path: 'booking', element: <OverviewBookingPage /> },
      { path: 'file', element: <OverviewFilePage /> },
      {
        path: 'user',
        children: [
          { element: <UserProfilePage />, index: true },
          { path: 'profile', element: <UserProfilePage /> },
          { path: 'cards', element: <UserCardsPage /> },
          { path: 'list', element: <UserListPage /> },
          { path: 'new', element: <UserCreatePage /> },
          { path: ':id/edit', element: <UserEditPage /> },
          { path: 'account', element: <UserAccountPage /> },
        ],
      },
      {
        path: 'articletype',
        children: [
          { element: <ArticleTypeListPage />, index: true }, 
          { path: 'list', element: <ArticleTypeListPage /> },
          { path: ':id', element: <ArticleTypeDetailsPage /> },
          { path: 'new', element: <ArticleTypeCreatePage /> },
          { path: ':id/edit', element: <ArticleTypeEditPage /> },
        ],
      },
      {
        path: 'blog', 
        children: [ 
          { element: <BlogPostsPage />, index: true }, 
          { path: 'list', element: <BlogPostsPage /> },
          { path: ':id', element: <BlogPostPage /> },
          { path: ':id/edit', element: <BlogEditPostPage /> },
          { path: 'new', element: <BlogNewPostPage /> },
        ],
      }, 
      {
        path: 'vuontrong', 
        children: [  
          { element: <VuongTrongListPage />, index: true }, 
          { path: 'list', element: <VuongTrongListPage /> },
           { path: ':id', element: <VuongTrongListPage /> },
          { path: ':id/edit', element: <VuongTrongEditPage /> },
          { path: 'new', element: <VuongTrongNewPage /> },
         
        ],
      },
      
      { path: 'file-manager', element: <FileManagerPage /> },
      {
        path: 'menu',
        children: [
          { element: <MenuListPage />, index: true },
          { path: 'list', element: <MenuListPage /> },
          { path: 'new', element: <MenuNewPage /> },
          { path: ':id/edit', element: <MenuEditPage /> },
        ],
      },
      {
        path: 'account',  
        children: [
          { element: <AccountListPage />, index: true },
          { path: 'list', element: <AccountListPage /> },
          { path: ':id/edit', element: <AccountEditPage /> }, 
          { path: 'new', element: <AccountNewPage /> }, 
        ],
      },
      {
        path: 'losam',
        children: [
          { element: <TraCuuLoSamPage />, index: true },
          { path: 'tracuu', element: <TraCuuLoSamPage /> },
          { path: 'list', element: <LoSamListPage /> }, 
          { path: ':id/edit', element: <LoSamEditPage /> }, 
          { path: 'new', element: <LoSamNewPage /> }, 
        ],
      },
      { 
        path: 'vaitro',
        children: [
          { element: <RoleListPage />, index: true },
          { path: 'list', element: <RoleListPage /> },
          { path: 'new', element: <RoleNewPage /> },
          { path: ':id/edit', element: <RoleEditPage /> },
        ],
      },
      { path: 'permission', element: <PermissionDeniedPage /> },
      { path: 'blank', element: <BlankPage /> },
      {
        path: 'home', 
        children: [
          { path: 'profile', element: <HomeProfilePage /> },
        ],
      },
    ],
  },
]; 
